"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.middlewareRedirectorUnregisteredPages = exports.getProvincesByShort = exports.deleteDoubleFiltersInSeoUrl = exports.checkWhitelistFiltersInCommonWith = exports.checkIfFiltersAreValidJustForResidential = exports.getProvinceList = exports.normalizeSrpUrlData = exports.getNewZones = exports.getNewZonesFrom = exports.getPluralLTgGroup = exports.getPluralPropertyType = exports.middlewareRedirectorSEOPages = exports.middlewareRedirectorPublishersSrp = exports.middlewareRedirectorPublishers = exports.middlewareRedirector = exports.checkIfSmallTown = exports.hasMasterSearchCanonical = exports.isTorinoProvinceTown = exports.getAllPropertyTypesPlural = exports.getAllPropertyTypesSingular = exports.getPropertyTypeGroup = exports.getBuldingConditionsEncode = exports.getPublisherTypeEncode = exports.getRoomsDecode = exports.getRoomsEncode = exports.getObjByCategoryImmotypeStatic = exports.getPropertyTypes = exports.isSrpUrl = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _superagent = _interopRequireDefault(require("superagent"));

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _NewZonesHelpers = require("../helpers/NewZonesHelpers");

var _citiesWithAtLeastARedirect = require("../helpers/citiesWithAtLeastARedirect");

var _smallTownsList = require("../helpers/smallTownsList");

var _torinoTownsList = require("../helpers/torinoTownsList");

var _homonymoustowns = _interopRequireDefault(require("../helpers/homonymoustowns.json"));

var _getSmallTownsList = _interopRequireWildcard(require("../helpers/getSmallTownsList"));

var _slugify = require("../helpers/slugify");

var _MiddlewareRedirectHelper = require("../helpers/MiddlewareRedirectHelper");

var _SeoManager = _interopRequireDefault(require("../SeoManager"));

var _CasaOldLocationHelper = require("../helpers/CasaOldLocationHelper");

var _hashkeyRedirectObject = require("../helpers/hashkeyRedirectObject");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var isSrpUrl = function isSrpUrl(uri) {
  var regexp = /^\/(en|fr|de|it)\/srp$|^\/(en|fr|de|it)\/srp\/$|^\/(en|fr|de|it)\/srp\?.*|^\/(en|fr|de|it)\/srp\/\?.*|^\/srp\/\?.*|^\/srp\/|^\/(en|fr|de|it)\/srp\/map$|^\/(en|fr|de|it)\/srp\/map\/$|^\/(en|fr|de|it)\/srp\/map\?.*|^\/(en|fr|de|it)\/srp\/map\/\?.*|^\/srp\/map\/\?.*|^\/srp\/map\/|^\/agenzie\/srp\/|^\/srp\?.*/;
  return regexp.test(uri);
};

exports.isSrpUrl = isSrpUrl;

var getPropertyTypes = function getPropertyTypes(lang) {
  return (0, _SeoManagerHelpers.getImmotypeLK)(lang);
};

exports.getPropertyTypes = getPropertyTypes;

var getObjByCategoryImmotypeStatic = function getObjByCategoryImmotypeStatic(lang, category, ptype) {
  try {
    var ptypes = (0, _SeoManagerHelpers.getObjByCategoryImmotype)(lang, ptype);

    if (ptypes.category === category) {
      return ptypes;
    }

    return null;
  } catch (error) {
    return null;
  }
};

exports.getObjByCategoryImmotypeStatic = getObjByCategoryImmotypeStatic;

var getRoomsEncode = function getRoomsEncode(lang) {
  return _SeoManagerHelpers.ROOMS_ENCODE;
};

exports.getRoomsEncode = getRoomsEncode;

var getRoomsDecode = function getRoomsDecode(lang) {
  return _SeoManagerHelpers.ROOMS_DECODE;
};

exports.getRoomsDecode = getRoomsDecode;

var getPublisherTypeEncode = function getPublisherTypeEncode(lang) {
  return _SeoManagerHelpers.PUBLISHER_TYPE_ENCODE[lang];
};

exports.getPublisherTypeEncode = getPublisherTypeEncode;

var getBuldingConditionsEncode = function getBuldingConditionsEncode(lang) {
  return _SeoManagerHelpers.BUILDING_CONDITION_ENCODE[lang];
};

exports.getBuldingConditionsEncode = getBuldingConditionsEncode;

var getPropertyTypeGroup = function getPropertyTypeGroup(lang) {
  return _SeoManagerHelpers.PROPERTY_TYPES_GROUP_KEYS[lang];
};

exports.getPropertyTypeGroup = getPropertyTypeGroup;

var getAllPropertyTypesSingular = function getAllPropertyTypesSingular() {
  return Object.keys(_SeoManagerHelpers.PROPERTY_TYPES_SINGULAR);
};

exports.getAllPropertyTypesSingular = getAllPropertyTypesSingular;

var getAllPropertyTypesPlural = function getAllPropertyTypesPlural() {
  return Object.keys(_SeoManagerHelpers.PROPERTY_TYPES_PLURAL).map(function (ptype) {
    return (0, _slugify.slugify)(_SeoManagerHelpers.PROPERTY_TYPES_PLURAL[ptype]);
  });
};

exports.getAllPropertyTypesPlural = getAllPropertyTypesPlural;

var respToReturnIfIsARedirect = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var _ref$paramsV2OK, paramsV2OK, _ref$forceSrp, forceSrp, _ref$locations, locations, seoManager, redirectProperties, _ref$oldUrl, oldUrl, isMap, seoParams, urlOK, encoded_url, encoded_301_url;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$paramsV2OK = _ref.paramsV2OK, paramsV2OK = _ref$paramsV2OK === void 0 ? {} : _ref$paramsV2OK, _ref$forceSrp = _ref.forceSrp, forceSrp = _ref$forceSrp === void 0 ? true : _ref$forceSrp, _ref$locations = _ref.locations, locations = _ref$locations === void 0 ? [] : _ref$locations, seoManager = _ref.seoManager, redirectProperties = _ref.redirectProperties, _ref$oldUrl = _ref.oldUrl, oldUrl = _ref$oldUrl === void 0 ? '' : _ref$oldUrl;
            isMap = oldUrl.indexOf('srp/map') > -1;
            seoParams = Object.assign({}, _objectSpread({}, paramsV2OK, {
              forceSrp: forceSrp,
              locations: locations,
              isMap: isMap
            }));
            urlOK = seoManager.encode(seoParams);
            encoded_url = encodeURIComponent(decodeURIComponent(oldUrl.toLowerCase()));
            encoded_301_url = encodeURIComponent(decodeURIComponent(urlOK.toLowerCase()));

            if (encoded_url !== encoded_301_url) {
              redirectProperties.isARedirect = true;
              redirectProperties.url = urlOK;
              redirectProperties.statusCode = 301;
            }

            return _context.abrupt("return", redirectProperties);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function respToReturnIfIsARedirect(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var redirectParamsBasedOnFilters = function redirectParamsBasedOnFilters(params) {
  var filterskeys = ['garden', 'balcony', 'terrace', 'heatingType', 'lift', 'numParkingSpaces', 'only_auction', 'availability', 'has_swimming_pool'];
  var searchHasFilters = false;
  var redirectParams = JSON.parse(JSON.stringify(params));
  Object.keys(redirectParams).forEach(function (param) {
    if (filterskeys.includes(param)) {
      // la redirect deve puntare alla ricerca master, quindi rimuoviamo i filtri seo
      // che poi dovrebbe essere uno solo a questo punto
      delete redirectParams[param];
      searchHasFilters = true;
    }
  });
  return {
    searchHasFilters: searchHasFilters,
    redirectParams: redirectParams
  };
};

var isTorinoProvinceTown = function isTorinoProvinceTown(name) {
  return _torinoTownsList.TORINO_TOWNS.indexOf(name) > -1;
};

exports.isTorinoProvinceTown = isTorinoProvinceTown;

var hasMasterSearchCanonical = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params) {
    var _params$locations, locations, _locations, loc, name, _redirectParamsBasedO, searchHasFilters, redirectParams, isSmallTown;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // se abbiamo località
            // se la località è singola
            // se la localita è un comune o una zona
            // se il comune è nella provincia di torino
            _params$locations = params.locations, locations = _params$locations === void 0 ? [] : _params$locations;

            if (!(!locations.length || locations.length > 1)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", false);

          case 3:
            _locations = _slicedToArray(locations, 1), loc = _locations[0];

            if (!(!loc.level || loc.level < 9 || loc.level === 999)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", false);

          case 6:
            name = loc.slug;

            if (!(loc.level > 9)) {
              _context2.next = 13;
              break;
            }

            if (!(loc.parent && loc.parent.town && loc.parent.town.slug)) {
              _context2.next = 12;
              break;
            }

            name = loc.parent.town.slug;
            _context2.next = 13;
            break;

          case 12:
            return _context2.abrupt("return", false);

          case 13:
            if (!(_torinoTownsList.TORINO_TOWNS.indexOf(name) === -1)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", false);

          case 15:
            // se abbiamo filtri seo
            _redirectParamsBasedO = redirectParamsBasedOnFilters(params), searchHasFilters = _redirectParamsBasedO.searchHasFilters, redirectParams = _redirectParamsBasedO.redirectParams;

            if (searchHasFilters) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("return", false);

          case 18:
            _context2.next = 20;
            return checkIfSmallTown(params, {});

          case 20:
            isSmallTown = _context2.sent;

            if (isSmallTown) {
              _context2.next = 23;
              break;
            }

            return _context2.abrupt("return", false);

          case 23:
            return _context2.abrupt("return", redirectParams);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function hasMasterSearchCanonical(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.hasMasterSearchCanonical = hasMasterSearchCanonical;

var isSmallTownRedirect = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var params,
        opts,
        _redirectParamsBasedO2,
        searchHasFilters,
        redirectParams,
        _opts$isLocalTest,
        isLocalTest,
        s3configFiles,
        isSmallTown,
        _args3 = arguments;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
            opts = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            // per minimizzare l'uso di checkIfSmallTown controlliamo prima se la seo url
            // contiene filtri seo
            _redirectParamsBasedO2 = redirectParamsBasedOnFilters(params), searchHasFilters = _redirectParamsBasedO2.searchHasFilters, redirectParams = _redirectParamsBasedO2.redirectParams; // se non è url seo di una ricerca filtrata, non dobbiamo far niente
            // ed evitiamo l'eventuale chiamata

            if (searchHasFilters) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", false);

          case 5:
            _opts$isLocalTest = opts.isLocalTest, isLocalTest = _opts$isLocalTest === void 0 ? false : _opts$isLocalTest, s3configFiles = opts.s3configFiles; // se non è una small town, non dobbiamo far niente

            _context3.next = 8;
            return checkIfSmallTown(params, {
              addProvinceIfPresent: true,
              isLocalTest: isLocalTest,
              s3configFiles: s3configFiles
            });

          case 8:
            isSmallTown = _context3.sent;

            if (isSmallTown) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", false);

          case 11:
            return _context3.abrupt("return", redirectParams);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function isSmallTownRedirect() {
    return _ref4.apply(this, arguments);
  };
}();

var checkIfSmallTown = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var params,
        opts,
        _opts$addProvinceIfPr,
        addProvinceIfPresent,
        _opts$isLocalTest2,
        isLocalTest,
        _opts$s3configFiles,
        s3configFiles,
        s3Data,
        _params$locations2,
        locations,
        _locations2,
        loc,
        name,
        hasIndex,
        _args4 = arguments;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            params = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            opts = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _opts$addProvinceIfPr = opts.addProvinceIfPresent, addProvinceIfPresent = _opts$addProvinceIfPr === void 0 ? false : _opts$addProvinceIfPr, _opts$isLocalTest2 = opts.isLocalTest, isLocalTest = _opts$isLocalTest2 === void 0 ? false : _opts$isLocalTest2, _opts$s3configFiles = opts.s3configFiles, s3configFiles = _opts$s3configFiles === void 0 ? 'https://app.casa.it' : _opts$s3configFiles;

            if (!isLocalTest) {
              _context4.next = 7;
              break;
            }

            global.SM__SMALLTOWNS__DATA = _smallTownsList.SMALL_TOWNS;
            _context4.next = 13;
            break;

          case 7:
            if (!(!global.SM__SMALLTOWNS__DATA // se non esiste la variabile
            || global.SM__SMALLTOWNS__DATA.error // se stiamo usando la lista staticizzata in fase di build
            || global.SM__SMALLTOWNS__DATA.updateDt && (0, _getSmallTownsList.shouldRefreshSmallTownsList)(global.SM__SMALLTOWNS__DATA.updateDt) // se la lista è stata scaricata da più di 1 giorno
            )) {
              _context4.next = 13;
              break;
            }

            (0, _getSmallTownsList.logSmallTownsListRefreshReason)(global.SM__SMALLTOWNS__DATA, s3configFiles);
            _context4.next = 11;
            return (0, _getSmallTownsList["default"])(s3configFiles);

          case 11:
            s3Data = _context4.sent;

            // nel caso in cui la chiamata a s3 sia andata in errore
            // o abbia restituito una lista vuota, usiamo la lista staticizzata
            if (s3Data.error) {
              global.SM__SMALLTOWNS__DATA = _smallTownsList.SMALL_TOWNS;
            } else {
              global.SM__SMALLTOWNS__DATA = s3Data;
            }

          case 13:
            _params$locations2 = params.locations, locations = _params$locations2 === void 0 ? [] : _params$locations2;

            if (!(!locations.length || locations.length > 1)) {
              _context4.next = 16;
              break;
            }

            return _context4.abrupt("return", false);

          case 16:
            _locations2 = _slicedToArray(locations, 1), loc = _locations2[0];

            if (!(loc.level < 9 || loc.level === 999)) {
              _context4.next = 19;
              break;
            }

            return _context4.abrupt("return", false);

          case 19:
            name = loc.slug; // zona o quartiere: ci basiamo sul nome del comune 
            // escludiamo le località mappa

            if (!(loc.level > 9)) {
              _context4.next = 26;
              break;
            }

            if (!(loc.parent && loc.parent.town && loc.parent.town.slug)) {
              _context4.next = 25;
              break;
            }

            name = loc.parent.town.slug;
            _context4.next = 26;
            break;

          case 25:
            return _context4.abrupt("return", false);

          case 26:
            // loc.parent.province: ci arriva dal seomanagemiddleware se abbiamo un comune con disambiguazione (san-teodoro-me)
            // ma ci arriva sempre quando abbiamo la resolved
            // quindi:
            // - in caso di richiesta del seomanagermiddleware lo usiamo sempre (addProvinceIfPresent da isSmallTownRedirect)
            // - in caso di richiesta da portale lo usiamo solo se sappiamo che il comune è uno di quelli della lista degli omonimi
            if (loc.parent.province && (addProvinceIfPresent || _homonymoustowns["default"][name])) {
              name += "-".concat(loc.parent.province["short"].toLowerCase());
            } // TECH-7641
            // in caso di richiesta del seomanagermiddleware (addProvinceIfPresent da isSmallTownRedirect)
            // controlliamo se si tratta di un comune della provincia di Torino


            if (!(addProvinceIfPresent && _torinoTownsList.TORINO_TOWNS.indexOf(name) > -1)) {
              _context4.next = 29;
              break;
            }

            return _context4.abrupt("return", false);

          case 29:
            hasIndex = SM__SMALLTOWNS__DATA.townsConfig.indexOf(name);

            if (!(hasIndex > -1)) {
              _context4.next = 32;
              break;
            }

            return _context4.abrupt("return", true);

          case 32:
            return _context4.abrupt("return", false);

          case 33:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function checkIfSmallTown() {
    return _ref5.apply(this, arguments);
  };
}();

exports.checkIfSmallTown = checkIfSmallTown;

var middlewareRedirector = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(url, config) {
    var _PTYPES_CONVERSIONS_T;

    var _ref7,
        _ref7$from,
        from,
        _ref7$isLocalTest,
        isLocalTest,
        seoManager,
        seoDec,
        isValid,
        isOldSeoUrl,
        isAgencySrpUrl,
        isANonAdminZone,
        isASrpUrl,
        redirectProperties,
        paramsV2OK,
        urlOK,
        _paramsV2OK,
        REGEXP_POINT,
        matchAPoint,
        REGEXP_APEX,
        matchAnApex,
        REGEXP_TWOPOINTS,
        matchATwoPoints,
        REGEXP_HYPHEN,
        matchAFinalHyphex,
        REGEXP_STARTING_HYPHEN,
        matchAnInitialHyphex,
        REGEXP_WRONG_SURROUNDING_WORD,
        matchWrongSurrounding,
        REGEXP_BRACKET,
        matchBrackets,
        _checkNewConstriction,
        is404,
        redProperties,
        esapi_url,
        body,
        resL,
        zones,
        apilh_url,
        _resL,
        locationsOK,
        lengthPropertyTypes,
        chooseL9,
        l9ToUse,
        mapNewLocalities,
        selectedNewBlocks,
        selectedNewZones,
        selectedNewTowns,
        _paramsV2OK2,
        isRoomsNumber,
        numRoomsMin,
        numRoomsMax,
        i,
        qs,
        qsWithoutDoubleFilters,
        qsToDelete,
        hasToRedirect,
        useSyncEncode,
        _paramsV2OK3,
        locations,
        hashKey,
        _urlOK,
        encoded_url,
        encoded_301_url,
        locFreeText404,
        _url,
        smalltownsRedirectParams,
        _url2,
        REGEXP_SRP,
        matchSrp,
        _paramsV2OK4,
        _locations3,
        traspasosPtypesToRedirect,
        forceSrp,
        doRedirect,
        isZoneRedirect,
        mapZones,
        urlHashkeys,
        zonesToEncode,
        pt,
        ltg,
        _urlOK2,
        REGEXP_GALLERY_OR_MAP,
        matchAGalleryOrAMap,
        urlToUse,
        isPublisherRoot,
        isAgentPro,
        pid,
        pidPos,
        pidEndPos,
        fixedUrl,
        checkForSlugSlashes,
        newSeoDec,
        newIsValid,
        _paramsV2OK6,
        _urlOK4,
        _paramsV2OK5,
        _urlOK3,
        _encoded_url,
        _encoded_301_url,
        _args5 = arguments;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref7 = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {}, _ref7$from = _ref7.from, from = _ref7$from === void 0 ? '' : _ref7$from, _ref7$isLocalTest = _ref7.isLocalTest, isLocalTest = _ref7$isLocalTest === void 0 ? false : _ref7$isLocalTest;
            seoManager = new _SeoManager["default"](config.domain, config.locale);
            seoDec = seoManager.decode(url);
            isValid = seoManager.isValidDecode();
            isOldSeoUrl = seoDec.seo_manager_type === 'old-seo-url';
            isAgencySrpUrl = seoDec.seo_manager_type === 'agency-srp';
            isANonAdminZone = seoDec.seo_manager_type === 'non-administrative-zones';
            isASrpUrl = isSrpUrl(url);
            redirectProperties = {
              isARedirect: false,
              statusCode: 200,
              url: url
            }; // non admin zone until 2024-09-21 dont have redirect, when they will have, 
            // we will remove this condition and try to redirect with the same logic as the srp urls

            if (!isANonAdminZone) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", redirectProperties);

          case 11:
            if (!(!isASrpUrl && seoDec.seo_decode_type && seoDec.seo_decode_type.level2 === 'license_type_groups' && seoDec.license_type_groups.slug === 'negozio' && ((_PTYPES_CONVERSIONS_T = _MiddlewareRedirectHelper.PTYPES_CONVERSIONS_TRASPASOS[seoDec.license_type_groups.slug]) === null || _PTYPES_CONVERSIONS_T === void 0 ? void 0 : _PTYPES_CONVERSIONS_T.propertyTypes))) {
              _context5.next = 22;
              break;
            }

            paramsV2OK = seoManager.convertParamsForEncode(config.locale, seoDec, isOldSeoUrl);
            paramsV2OK.category = 'commerciale';
            paramsV2OK.propertyTypeGroup = 'commerciale';
            paramsV2OK.propertyTypes = [_MiddlewareRedirectHelper.PTYPES_CONVERSIONS_TRASPASOS[seoDec.license_type_groups.slug].propertyTypes];
            delete paramsV2OK.license_type_groups;
            urlOK = seoManager.encode(paramsV2OK);
            redirectProperties.isARedirect = true;
            redirectProperties.url = urlOK;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 22:
            if (!(isOldSeoUrl && from !== 'PublisherSrp')) {
              _context5.next = 27;
              break;
            }

            redirectProperties.statusCode = 404;
            return _context5.abrupt("return", redirectProperties);

          case 27:
            if (!(isValid && !isAgencySrpUrl)) {
              _context5.next = 167;
              break;
            }

            _paramsV2OK = seoManager.convertParamsForEncode(config.locale, seoDec, isOldSeoUrl);
            /* URL WITH POINTS */

            REGEXP_POINT = new RegExp(/(\.-|\.(?!\d+))/g);
            matchAPoint = url.match(REGEXP_POINT);
            /* URL WITH APEX */

            REGEXP_APEX = new RegExp(/(\')/g);
            matchAnApex = url.match(REGEXP_APEX);
            /* URL WITH TWO POINTS */

            REGEXP_TWOPOINTS = new RegExp(/(\:-)/g);
            matchATwoPoints = url.match(REGEXP_TWOPOINTS);

            if (!(matchAPoint && matchAPoint.length > 0 || matchAnApex && matchAnApex.length > 0 || matchATwoPoints && matchATwoPoints.length > 0)) {
              _context5.next = 44;
              break;
            }

            REGEXP_POINT.lastIndex = 0;
            REGEXP_APEX.lastIndex = 0;
            REGEXP_TWOPOINTS.lastIndex = 0;
            url = url.replace(/(\.-|\.|\'|\:-)/g, '-');
            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 44:
            /* URL WITH ENDING HYPHEN */
            REGEXP_HYPHEN = new RegExp(/(\-\/)/g);
            matchAFinalHyphex = url.match(REGEXP_HYPHEN);

            if (!(matchAFinalHyphex && matchAFinalHyphex.length > 0)) {
              _context5.next = 53;
              break;
            }

            REGEXP_HYPHEN.lastIndex = 0;
            url = url.replace(/(\-\/)/g, '/');
            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 53:
            /* URL WITH STARTING HYPHEN */
            REGEXP_STARTING_HYPHEN = new RegExp(/(\/-)/g);
            matchAnInitialHyphex = url.match(REGEXP_STARTING_HYPHEN);

            if (!(matchAnInitialHyphex && matchAnInitialHyphex.length > 0)) {
              _context5.next = 62;
              break;
            }

            REGEXP_STARTING_HYPHEN.lastIndex = 0;
            url = url.replace(/(\/-)/g, '/');
            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 62:
            /* URL WITH SURROUNDING WROTE WRONGLY  */
            REGEXP_WRONG_SURROUNDING_WORD = new RegExp(/(surroundigs)=(true|false)/g);
            matchWrongSurrounding = REGEXP_WRONG_SURROUNDING_WORD.exec(url);

            if (!(matchWrongSurrounding && matchWrongSurrounding.length > 2)) {
              _context5.next = 71;
              break;
            }

            REGEXP_WRONG_SURROUNDING_WORD.lastIndex = 0;

            if (matchWrongSurrounding[2] === 'true') {
              url = url.replace(/(surroundigs)=(true|false)/g, 'surrounding=true');
            } else {
              url = url.replace(/(surroundigs)=(true|false)/g, '');
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 71:
            /* REMOVE BRACKET */
            REGEXP_BRACKET = new RegExp(/\(.*\)/g);
            matchBrackets = url.match(REGEXP_BRACKET);

            if (!(matchBrackets && matchBrackets.length > 0)) {
              _context5.next = 80;
              break;
            }

            REGEXP_BRACKET.lastIndex = 0;
            url = url.replace(/\(|\)/g, '');
            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 80:
            /* Give 404 to urls with commercial and new construction */
            _checkNewConstriction = (0, _MiddlewareRedirectHelper.checkNewConstrictionWithCommercial)(_paramsV2OK), is404 = _checkNewConstriction.is404, redProperties = _checkNewConstriction.redProperties;

            if (!is404) {
              _context5.next = 84;
              break;
            }

            redirectProperties = _objectSpread({}, redirectProperties, {}, redProperties);
            return _context5.abrupt("return", redirectProperties);

          case 84:
            if (_paramsV2OK.abQuality || _paramsV2OK.ft || _paramsV2OK.loc) {
              redirectProperties = _objectSpread({}, redirectProperties, {
                statusCode: 404
              });
            }

            if (!_paramsV2OK.freetext) {
              _context5.next = 93;
              break;
            }

            esapi_url = config.api.esapi;
            body = {
              site: 'it_casa',
              page: 0,
              size: 0,
              query: [{
                where: _paramsV2OK.freetext
              }]
            };
            _context5.next = 90;
            return (0, _MiddlewareRedirectHelper.callApi)(esapi_url, _MiddlewareRedirectHelper.HTTP_VERB_POST, body);

          case 90:
            resL = _context5.sent;
            _paramsV2OK.locations = resL ? resL.resolved_locations : [];
            delete _paramsV2OK.freetext;

          case 93:
            if (_paramsV2OK.postalcode) {
              _paramsV2OK.locations = _paramsV2OK.postalcode.map(function (ptype) {
                return {
                  type: 'postalcode',
                  name: ptype.postalcode,
                  slug: ptype.postalcode
                };
              });
              delete _paramsV2OK.postalcode;
            }

            zones = _paramsV2OK.zones || _paramsV2OK.zone || null;

            if (!zones) {
              _context5.next = 103;
              break;
            }

            apilh_url = config.api.apiLHLocations.replace(/{zones}/gi, zones).replace(/{site}/gi, 'it_casa');
            _context5.next = 99;
            return (0, _MiddlewareRedirectHelper.callApi)(apilh_url, _MiddlewareRedirectHelper.HTTP_VERB_GET);

          case 99:
            _resL = _context5.sent;
            _paramsV2OK.locations = _resL ? _resL.locations : [];
            delete _paramsV2OK.zones;
            delete _paramsV2OK.zone;

          case 103:
            if (_paramsV2OK.photo === false) {
              delete _paramsV2OK.photo;
            }

            if (_paramsV2OK.page === '1' || _paramsV2OK.page === 1 || _paramsV2OK.page < 1) {
              delete _paramsV2OK.page;
            }

            if (_paramsV2OK.sortType === 'relevance') {
              delete _paramsV2OK.sortType;
            }

            if (_paramsV2OK.page && parseInt(_paramsV2OK.page, 10) > 500) {
              _paramsV2OK.page = 1;
            }

            locationsOK = _paramsV2OK.locations;
            lengthPropertyTypes = _paramsV2OK.propertyTypes ? _paramsV2OK.propertyTypes.length : 0; // paramsV2OK.version =
            //   paramsV2OK.publisherId || paramsV2OK.detailAgencyId ? 'seo_v1' : 'seo_v2';

            _paramsV2OK.version = _paramsV2OK.detailAgencyId ? 'seo_v1' : 'seo_v2';

            if (locationsOK && locationsOK.length === 1 && _paramsV2OK.qgeo && isOldSeoUrl && lengthPropertyTypes <= 1) {
              delete _paramsV2OK.qgeo;
            }

            if (isOldSeoUrl && parseInt(_paramsV2OK.page, 10) > 1) {
              delete _paramsV2OK.page;
            }

            if ('misc' in _paramsV2OK) {
              if (Array.isArray(_paramsV2OK.misc)) {
                _paramsV2OK.misc = _paramsV2OK.misc[0];
              }

              if (_paramsV2OK.misc === 'undefined' || _paramsV2OK.misc === undefined) {
                delete _paramsV2OK.misc;
              }
            }

            chooseL9 = function chooseL9() {
              var l9Slug = null;

              if (_paramsV2OK.geo && _paramsV2OK.geo.l9) {
                l9Slug = _paramsV2OK.geo.l9.adm;

                if (!_citiesWithAtLeastARedirect.CITIES_NEW_ZONES.includes(l9Slug) && _paramsV2OK.geo && _paramsV2OK.geo.l6 && _paramsV2OK.geo.l6["short"]) {
                  if (_citiesWithAtLeastARedirect.CITIES_NEW_ZONES.includes("".concat(_paramsV2OK.geo.l9.adm, "-").concat(_paramsV2OK.geo.l6["short"]))) {
                    l9Slug = "".concat(_paramsV2OK.geo.l9.adm, "-").concat(_paramsV2OK.geo.l6["short"]);
                  }
                }
              }

              return l9Slug;
            };

            l9ToUse = chooseL9(); // Case SAN-MARINO

            if (_paramsV2OK.geo && _paramsV2OK.geo.l6 && _paramsV2OK.geo.l6.adm && _paramsV2OK.geo.l6.adm === 'san-marino') {
              _paramsV2OK.geo.l6.adm = 'repubblica-di-san-marino';
              _paramsV2OK.geo.l6["short"] = 'repubblica-di-san-marino';
              _paramsV2OK.geo.l6.name = 'repubblica-di-san-marino';
              _paramsV2OK.locations = _paramsV2OK.locations.map(function (loc) {
                loc.level = 6;
                loc.slug = 'repubblica-di-san-marino';
                loc.name = 'repubblica-di-san-marino';
                loc["short"] = 'repubblica-di-san-marino';
                return loc;
              });
            }

            if (_paramsV2OK.geo && _paramsV2OK.geo.l9 && !_paramsV2OK.geo.l118 && !_paramsV2OK.geo.l120 && l9ToUse && _citiesWithAtLeastARedirect.CITIES_NEW_ZONES.includes(l9ToUse)) {
              mapNewLocalities = _SeoManager["default"].getNewZonesFrom(l9ToUse);

              if (_paramsV2OK.geo.l11 && _paramsV2OK.geo.l11.block) {
                selectedNewBlocks = mapNewLocalities[_paramsV2OK.geo.l11.block];

                if (selectedNewBlocks && selectedNewBlocks.length) {
                  _paramsV2OK.locations = _paramsV2OK.locations.map(function (loc) {
                    if (loc.level === 11 && loc.type === 'block' && _paramsV2OK.geo.l11.block === loc.slug) {
                      /**
                       * NEW CONDITION TO REDIRECT BASED ON JSON DEPTH
                       */
                      var _selectedNewBlocks$ = selectedNewBlocks[0],
                          levelFrom = _selectedNewBlocks$.levelFrom,
                          levelTo = _selectedNewBlocks$.levelTo,
                          slugLevelParent = _selectedNewBlocks$.slugLevelParent,
                          slug = _selectedNewBlocks$.slug;

                      if (levelFrom === loc.level) {
                        // avoid homonymous loc for different level
                        switch (levelTo) {
                          case 9:
                            delete loc.parent;
                            loc.slug = slug;
                            loc.name = slug;
                            loc.type = 'town';
                            loc.level = 9;
                            break;

                          case 10:
                            if (slugLevelParent) {
                              loc.parent.zone = {
                                level: 10,
                                name: slugLevelParent,
                                slug: slugLevelParent
                              };
                            }

                            loc.slug = slug;
                            loc.name = slug;
                            loc.type = 'zone';
                            loc.level = 10;
                            break;

                          case 11:
                            if (slugLevelParent) {
                              loc.parent.zone = {
                                level: 10,
                                name: slugLevelParent,
                                slug: slugLevelParent
                              };
                              loc.slug = slug;
                              loc.name = slug;
                              loc.type = 'block';
                              loc.level = 11;
                            } else {
                              loc.slug = slug;
                              loc.name = slug;
                            }

                            break;

                          default:
                            break;
                        }

                        return loc;
                      } else if (!levelFrom) {
                        loc.slug = slug;
                        loc.name = slug;
                        return loc;
                      }
                    }

                    return loc;
                  });
                }
              }

              if (_paramsV2OK.geo.l10 && _paramsV2OK.geo.l10.zone) {
                selectedNewZones = mapNewLocalities[_paramsV2OK.geo.l10.zone];

                if (selectedNewZones && selectedNewZones.length) {
                  _paramsV2OK.locations = _paramsV2OK.locations.map(function (loc) {
                    if (loc.level === 10 && loc.type === 'zone' && _paramsV2OK.geo.l10.zone === loc.slug) {
                      /**
                       * NEW CONDITION TO REDIRECT BASED ON JSON DEPTH
                       */
                      var _selectedNewZones$ = selectedNewZones[0],
                          levelFrom = _selectedNewZones$.levelFrom,
                          levelTo = _selectedNewZones$.levelTo,
                          slugLevelParent = _selectedNewZones$.slugLevelParent,
                          slug = _selectedNewZones$.slug;

                      if (levelFrom === loc.level) {
                        // avoid homonymous loc for different level
                        switch (levelTo) {
                          case 9:
                            delete loc.parent;
                            loc.slug = slug;
                            loc.name = slug;
                            loc.type = 'town';
                            loc.level = 9;
                            break;

                          case 10:
                            loc.slug = slug;
                            loc.name = slug;
                            break;

                          case 11:
                            if (slugLevelParent) {
                              loc.parent.zone = {
                                level: 10,
                                name: slugLevelParent,
                                slug: slugLevelParent
                              };
                              loc.slug = slug;
                              loc.name = slug;
                              loc.type = 'block';
                              loc.level = 11;
                            }

                            break;

                          default:
                            break;
                        }

                        return loc;
                      } else if (!levelFrom) {
                        loc.slug = slug;
                        loc.name = slug;
                        return loc;
                      }
                    } else if (loc.parent && loc.parent.zone && loc.parent.zone.level === 10 && _paramsV2OK.geo.l10 && _paramsV2OK.geo.l10.zone === loc.parent.zone.slug) {
                      loc.parent.zone.slug = selectedNewZones[0].slug;
                    }

                    return loc;
                  });
                  _paramsV2OK.geo.l10.zone = selectedNewZones[0].slug;
                }
              }

              selectedNewTowns = mapNewLocalities[l9ToUse];

              if (selectedNewTowns && selectedNewTowns.length) {
                _paramsV2OK.locations = _paramsV2OK.locations.map(function (loc) {
                  if (loc.level === 9 && loc.type === 'town' && l9ToUse === loc.slug && (!selectedNewTowns[0].levelTo || selectedNewTowns[0].levelTo === 9)
                  /* 
                    OLD REDIRECTS (before 09/21) DONT HAVE LEVELTO, IN THAT CASE IS POSSIBLE
                    TO REDIRECT THE TOWN FOUND ON THE JSON, SINCE LATEST UPDATE IT'S 
                    MANDATORY TO HAVE LEVELTO, OTHERWISE IT WILL RAISE ISSUES WITH HOMONYMOUS
                    SLUGS BETWEEN LEVELS
                    ex: 
                    1. vendita/residenziale/davagna/
                    2. vendita/residenziale/davagna/davagna/
                    3. vendita/residenziale/davagna/davagna/davagna/
                  */
                  ) {
                      loc.slug = selectedNewTowns[0].slug;
                      loc.name = selectedNewTowns[0].slug;
                      return loc;
                    } else if (loc.parent && loc.parent.town && loc.parent.town.slug === l9ToUse && (!selectedNewTowns[0].levelTo || selectedNewTowns[0].levelTo === 9)) {
                    loc.parent.town.slug = selectedNewTowns[0].slug;
                    loc.parent.town.name = selectedNewTowns[0].slug;
                    return loc;
                  } else if (loc.parent && Object.keys(loc.parent).length === 0 && selectedNewTowns[0].levelTo === 10 && selectedNewTowns[0].levelFrom === 9 && selectedNewTowns[0].slugLevelParent) {
                    loc.slug = selectedNewTowns[0].slug;
                    loc.name = selectedNewTowns[0].slug;
                    loc.level = 10;
                    loc.type = 'zone';
                    loc.parent = {
                      town: {
                        slug: selectedNewTowns[0].slugLevelParent,
                        name: selectedNewTowns[0].slugLevelParent,
                        level: 9,
                        type: 'town'
                      }
                    };
                    return loc;
                  }

                  return loc;
                });
                _paramsV2OK.geo.l9.zone = selectedNewTowns[0].slug;
              }
            } // le vecchie seourl con magazzini per la decode ora sono url di località 
            // es. /vendita/magazzini/milano/ -> { geo: { l9: { adm: 'magazzini' }, l10: { zone: 'milano' } } }
            // forziamo a negozi-locali commerciali e ri-sottoponiamo il tutto a validazione post redirect
            // if (
            //   paramsV2OK.geo &&
            //   paramsV2OK.geo.l9 &&
            //   paramsV2OK.geo.l9.adm &&
            //   paramsV2OK.geo.l9.adm === 'magazzini'
            // ) {
            //   const fixedUrl = url.replace('magazzini', 'negozi-locali-commerciali');
            //   redirectProperties.isARedirect = true;
            //   redirectProperties.url = fixedUrl;
            //   redirectProperties.statusCode = 301;
            //   return redirectProperties;
            // }

            /* REDIRECT CON-DA-AGENZIE */


            if (_paramsV2OK.sellerType && Array.isArray(_paramsV2OK.sellerType)) {
              if (_paramsV2OK.sellerType.includes('agenzie')) {
                delete _paramsV2OK.sellerType;
              } else if (_paramsV2OK.sellerType.includes('costruttori')) {
                delete _paramsV2OK.sellerType;
                _paramsV2OK.buildingCondition = 'nuovo';
              }
            }

            if (_paramsV2OK.activeSort && _paramsV2OK.activeSort === 'undefined' || _paramsV2OK.sortType && _paramsV2OK.sortType === 'undefined') {
              delete _paramsV2OK.activeSort;
              delete _paramsV2OK.sortType;
            }
            /**
             * Redirect URL: 02-locali to bilocali
             * Redirect URL: 3-locali to trilocali
             */


            _paramsV2OK2 = _paramsV2OK, isRoomsNumber = _paramsV2OK2.isRoomsNumber, numRoomsMin = _paramsV2OK2.numRoomsMin, numRoomsMax = _paramsV2OK2.numRoomsMax;

            if (isRoomsNumber) {
              if (numRoomsMin && numRoomsMax) {
                i = [1, 2, 3, 4].indexOf(parseInt(numRoomsMin));

                if (i > -1) {
                  _paramsV2OK.numRoomsMin = i + 1;
                  _paramsV2OK.numRoomsMax = _paramsV2OK.numRoomsMin;
                }

                delete _paramsV2OK.isRoomsNumber;
              }
            }
            /************** RESTYLING ********************/
            // console.log('\n');
            // console.log('************** START **************');
            // console.log('OLD URL :', url);
            // console.log('OLD PARAMS:', paramsV2OK);


            (0, _MiddlewareRedirectHelper.checkParamsForNewPtypes)(_paramsV2OK, seoManager); // console.log('NEW PARAMS:', paramsV2OK);

            /**
             * TECH-6201 redirect from seoUrl with filters to url like /srp?...
             * TECH-6199 redirect from seoUrl with double filters con-e- to seo url with
             * only localities
             */

            qs = _objectSpread({}, _paramsV2OK, {}, _paramsV2OK.poi && {
              poi: _objectSpread({}, _paramsV2OK.poi)
            });
            qsWithoutDoubleFilters = deleteDoubleFiltersInSeoUrl({
              qs: qs
            });
            qsToDelete = qsWithoutDoubleFilters.qsToDelete, hasToRedirect = qsWithoutDoubleFilters.hasToRedirect;

            if (hasToRedirect) {
              _paramsV2OK = _objectSpread({}, qsToDelete);
            }

            useSyncEncode = checkWhitelistFiltersInCommonWith({
              qs: qs
            });

            if (!(useSyncEncode && !hasToRedirect)) {
              _context5.next = 134;
              break;
            }

            _paramsV2OK3 = _paramsV2OK, locations = _paramsV2OK3.locations; // URL SEO METRO don't have history redirect with that filter, so no redirect
            // is needed

            if (!(locations && locations.length === 1 && locations[0].type !== 'metrostop' && locations[0].type !== 'metroline')) {
              _context5.next = 134;
              break;
            }

            _context5.next = 132;
            return (0, _SeoManagerHelpers.getHashKeyFromSlugAndLevel)({
              loc: locations[0]
            });

          case 132:
            hashKey = _context5.sent;
            _paramsV2OK.locations[0].hkey = hashKey;

          case 134:
            _paramsV2OK = (0, _MiddlewareRedirectHelper.seoUrlHasTraspasosPtypesToRedirect)(_paramsV2OK);
            /************** RESTYLING ********************/

            _urlOK = seoManager.encode(_paramsV2OK); // console.log('paramsV2OK :', paramsV2OK);
            // console.log('NEW URL :', urlOK);
            // console.log('************** FINISH **************');
            // console.log('\n');

            encoded_url = encodeURIComponent(decodeURIComponent(url.toLowerCase()));
            encoded_301_url = encodeURIComponent(decodeURIComponent(_urlOK.toLowerCase()));

            if (!(encoded_url !== encoded_301_url // questa cosa non aveva senso, l'avevo messa io...
            // && !('publisherId' in paramsV2OK) // avoid redirect for publisher urls (generates double redirect by applying the 'remove slash if qs is present' rule)
            )) {
              _context5.next = 143;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 143:
            if (!_paramsV2OK.locations) {
              _context5.next = 148;
              break;
            }

            // eslint-disable-next-line consistent-return
            locFreeText404 = _paramsV2OK.locations.filter(function (l) {
              return l.level === 10 && ['indirizzi', 'zone commerciali'].includes(l.type);
            });

            if (!(locFreeText404.length > 0)) {
              _context5.next = 148;
              break;
            }

            redirectProperties.statusCode = 404;
            return _context5.abrupt("return", redirectProperties);

          case 148:
            if (!(_paramsV2OK.locations && _paramsV2OK.locations.map(function (l) {
              return ['freetext', 'postalcode'].includes(l.type) ? l : null;
            }).filter(Boolean).length > 0)) {
              _context5.next = 155;
              break;
            }

            _paramsV2OK.forceSrp = true;
            _url = seoManager.encode(_paramsV2OK);
            redirectProperties.isARedirect = true;
            redirectProperties.url = _url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 155:
            _context5.next = 157;
            return isSmallTownRedirect(_paramsV2OK, {
              isLocalTest: isLocalTest,
              s3configFiles: config.api.s3configFiles
            });

          case 157:
            smalltownsRedirectParams = _context5.sent;

            if (!smalltownsRedirectParams) {
              _context5.next = 164;
              break;
            }

            _url2 = seoManager.encode(smalltownsRedirectParams);
            redirectProperties.isARedirect = true;
            redirectProperties.url = _url2;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 164:
            return _context5.abrupt("return", redirectProperties);

          case 167:
            if (!isASrpUrl) {
              _context5.next = 191;
              break;
            }

            /* URL /SRP/ redirect to HOME */
            REGEXP_SRP = new RegExp(/((\/srp\/|\/srp|\/srp\/\?page=\d+)$)/g);
            matchSrp = url.match(REGEXP_SRP);

            if (!(matchSrp && matchSrp.length > 0)) {
              _context5.next = 177;
              break;
            }

            REGEXP_SRP.lastIndex = 0;
            url = '/';
            redirectProperties.isARedirect = true;
            redirectProperties.url = url;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 177:
            if (!seoDec.queryObject) {
              _context5.next = 189;
              break;
            }

            _paramsV2OK4 = seoManager.convertParamsForEncode('it', seoDec, isOldSeoUrl);
            _locations3 = [];
            traspasosPtypesToRedirect = (0, _MiddlewareRedirectHelper.hasTraspasosPtypesToRedirect)(seoDec.queryObject);
            forceSrp = true;
            doRedirect = false;
            isZoneRedirect = false;

            if (seoDec.queryObject.q && typeof seoDec.queryObject.q === 'string') {
              mapZones = _SeoManager["default"].getNewZones();
              urlHashkeys = seoDec.queryObject.q.split(',');
              zonesToEncode = (0, _NewZonesHelpers.getSplittedZones)(urlHashkeys, mapZones);

              if (zonesToEncode.toRedirect) {
                zonesToEncode.newHashKeys.map(function (hkey) {
                  _locations3.push({
                    hkey: hkey
                  });
                });

                if (!_paramsV2OK4.photo || _paramsV2OK4.photo === 'false') {
                  delete _paramsV2OK4.photo;
                }

                doRedirect = true;
                isZoneRedirect = true;
              }
            }

            if (traspasosPtypesToRedirect) {
              pt = [];
              ltg = [];
              traspasosPtypesToRedirect.map(function (ptype) {
                if (Object.keys(_MiddlewareRedirectHelper.PTYPES_CONVERSIONS_TRASPASOS).includes(ptype)) {
                  var _PTYPES_CONVERSIONS_T2 = _MiddlewareRedirectHelper.PTYPES_CONVERSIONS_TRASPASOS[ptype],
                      propertyTypeGroup = _PTYPES_CONVERSIONS_T2.propertyTypeGroup,
                      propertyTypes = _PTYPES_CONVERSIONS_T2.propertyTypes,
                      license_type_groups = _PTYPES_CONVERSIONS_T2.license_type_groups;

                  if (propertyTypeGroup) {
                    _paramsV2OK4.propertyTypeGroup = propertyTypeGroup;
                    delete _paramsV2OK4.propertyTypes;
                    forceSrp = false;
                  } else {
                    pt.push(propertyTypes);

                    if (license_type_groups) {
                      ltg.push(license_type_groups);
                    }
                  }
                }
              });
              pt = _toConsumableArray(new Set(pt));
              ltg = _toConsumableArray(new Set(ltg));

              if (pt.length) {
                _paramsV2OK4.propertyTypes = pt.join(',');
              }

              if (ltg.length) {
                _paramsV2OK4.license_type_groups = ltg.join(',');
              }

              doRedirect = true;
            }

            if (!isZoneRedirect && _paramsV2OK4.sellerType && _paramsV2OK4.sellerType.indexOf('costruttori') > -1) {
              // delete paramsV2OK.sellerType;
              _paramsV2OK4.sellerType = _paramsV2OK4.sellerType.split(',').filter(function (con) {
                return con !== 'costruttori';
              }).join(',');
              _paramsV2OK4.sellerType.length === 0 && delete _paramsV2OK4.sellerType;
              _paramsV2OK4.buildingCondition = _paramsV2OK4.buildingCondition ? _paramsV2OK4.buildingCondition.concat(',nuovo').split(',').filter(function (a, b, c) {
                return b === c.indexOf(a);
              }).join(',') : _paramsV2OK4.buildingCondition = 'nuovo';
              !_paramsV2OK4.photo && delete _paramsV2OK4.photo;
              doRedirect = true;
            }

            if (!doRedirect) {
              _context5.next = 189;
              break;
            }

            return _context5.abrupt("return", respToReturnIfIsARedirect({
              paramsV2OK: _paramsV2OK4,
              forceSrp: forceSrp,
              locations: _locations3,
              seoManager: seoManager,
              redirectProperties: redirectProperties,
              oldUrl: url
            }));

          case 189:
            _context5.next = 258;
            break;

          case 191:
            if (!(url === '/srp')) {
              _context5.next = 199;
              break;
            }

            /* FOR SEOMANAGER THIS ISNT A SEO URL NEITHER AN SRP URL */
            _urlOK2 = '/';
            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK2;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 199:
            /*URL NOT VALID BUT REDIRECT COULD BE VALID */
            REGEXP_GALLERY_OR_MAP = new RegExp(/(\/galleria-|\/mappa-).*/g);
            matchAGalleryOrAMap = url.match(REGEXP_GALLERY_OR_MAP);

            if (!(matchAGalleryOrAMap && matchAGalleryOrAMap.length > 0)) {
              _context5.next = 207;
              break;
            }

            REGEXP_GALLERY_OR_MAP.lastIndex = 0;
            url = url.replace(/(\/galleria-|\/mappa-).*/g, '');
            return _context5.abrupt("return", _SeoManager["default"].middlewareRedirector(url, config, {}));

          case 207:
            if (!(isOldSeoUrl && !isValid)) {
              _context5.next = 210;
              break;
            }

            /* ALL THE OLD URLS THAT DONT PASS THE LEVELS IN DECODE_LEVEL   */
            redirectProperties.statusCode = 404;
            return _context5.abrupt("return", redirectProperties);

          case 210:
            if (!(!isValid && !isASrpUrl && seoDec.seo_decode_type && (seoDec.seo_decode_type.level1 === 'publisherRoot' || seoDec.seo_decode_type.level1 === 'agentProRoot'))) {
              _context5.next = 246;
              break;
            }

            urlToUse = url;
            isPublisherRoot = seoDec.seo_decode_type.level1 === 'publisherRoot';
            isAgentPro = seoDec.seo_decode_type.level1 === 'agentProRoot';

            if (!isAgentPro) {
              _context5.next = 218;
              break;
            }

            urlToUse = url.replace('/agenti/', '');
            _context5.next = 230;
            break;

          case 218:
            if (!isPublisherRoot) {
              _context5.next = 230;
              break;
            }

            if (!( // url ends with //${number} or /${number}
            seoDec.seo_decode_type.level3 && seoDec.seo_decode_type.level3 === 'publisherId' && seoDec.seo_decode_type.level3 === seoDec.seo_decode_type.level2)) {
              _context5.next = 224;
              break;
            }

            // urlToUse = url.replace(`/${seoDec.publisherId}`, '');
            redirectProperties.statusCode = 404;
            return _context5.abrupt("return", redirectProperties);

          case 224:
            if (!/-[0-9]{1,8}(\/\/).+$/g.test(url)) {
              _context5.next = 229;
              break;
            }

            // url ends with //${string}
            redirectProperties.statusCode = 404;
            return _context5.abrupt("return", redirectProperties);

          case 229:
            if (/-[0-9]{1,8}(\/).+$/g.test(url) && seoDec.publisherId && !Number.isNaN(parseInt(seoDec.publisherId, 10))) {
              // url ends with /${string}
              pid = seoDec.publisherId;
              pidPos = url.indexOf(pid);
              pidEndPos = pidPos + pid.length;
              urlToUse = url.substring(0, pidEndPos);
              urlToUse = urlToUse[urlToUse.length - 1] !== '/' ? "".concat(urlToUse, "/") : urlToUse;
            }

          case 230:
            fixedUrl = urlToUse.replace(/\?/, '');
            checkForSlugSlashes = fixedUrl.replace('/agenzie/', '').replace(/\//g, '');
            fixedUrl = "/agenzie/".concat(checkForSlugSlashes).concat(isAgentPro ? '/agenti/' : '');
            newSeoDec = seoManager.decode(fixedUrl);
            newIsValid = seoManager.isValidDecode();

            if (!(newIsValid && (newSeoDec.isPublisherHp || newSeoDec.isAgentProPage))) {
              _context5.next = 245;
              break;
            }

            _paramsV2OK6 = seoManager.convertParamsForEncode(config.locale, newSeoDec, isOldSeoUrl);
            delete _paramsV2OK6.photo;
            _urlOK4 = seoManager.encode(_paramsV2OK6);
            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK4;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 245:
            if (!newIsValid && !('publisherId' in newSeoDec)) {
              redirectProperties.statusCode = 404;
            }

          case 246:
            _paramsV2OK5 = seoManager.convertParamsForEncode(config.locale, seoDec, isOldSeoUrl);
            _paramsV2OK5 = (0, _MiddlewareRedirectHelper.seoUrlHasTraspasosPtypesToRedirect)(_paramsV2OK5);
            _urlOK3 = seoManager.encode(_paramsV2OK5);
            _encoded_url = encodeURIComponent(decodeURIComponent(url.toLowerCase()));
            _encoded_301_url = encodeURIComponent(decodeURIComponent(_urlOK3.toLowerCase()));
            console.log('URL NOT VALID FOR SEOMANAGER :', url, '\n');
            console.log('urlOK >>:', _urlOK3);

            if (!(seoDec.seo_manager_type === 'transaction' && _encoded_301_url !== _encoded_url)) {
              _context5.next = 258;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK3;
            redirectProperties.statusCode = 301;
            return _context5.abrupt("return", redirectProperties);

          case 258:
            return _context5.abrupt("return", redirectProperties);

          case 259:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function middlewareRedirector(_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}();

exports.middlewareRedirector = middlewareRedirector;

var middlewareRedirectorPublishers = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6(url, config) {
    var urlSplitted, urlSplittedComplete, redirectProperties, defaultRedirect, urlOK, seoManager, publisherId, fixedUrl, newSeoDec, newIsValid, paramsV2OK, _urlOK6, level1, _urlOK5;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            urlSplitted = url.split('/').slice(1, -1);
            urlSplittedComplete = url.split('/').filter(Boolean);
            redirectProperties = {
              isARedirect: false,
              statusCode: 200,
              url: url
            };
            defaultRedirect = _objectSpread({}, redirectProperties);
            _context6.prev = 4;

            if (!(url.indexOf('/agenzie/agenzie') > -1)) {
              _context6.next = 11;
              break;
            }

            urlOK = "/".concat(url.replace('/agenzie/', ''));
            redirectProperties.isARedirect = true;
            redirectProperties.url = urlOK;
            redirectProperties.statusCode = 301;
            return _context6.abrupt("return", redirectProperties);

          case 11:
            if (!_MiddlewareRedirectHelper.PUBLISHERS_URLS_TO_REDIRECT.includes(urlSplitted[0])) {
              _context6.next = 37;
              break;
            }

            if (!(urlSplittedComplete[1].search(/da-\d+/g) > -1)) {
              _context6.next = 28;
              break;
            }

            seoManager = new _SeoManager["default"](config.domain, config.locale);
            publisherId = urlSplittedComplete[1].replace('da-', '');
            fixedUrl = "/agenzie/".concat(publisherId);
            newSeoDec = seoManager.decode(fixedUrl);
            newIsValid = seoManager.isValidDecode();

            if (!(newIsValid && newSeoDec.isPublisherHp)) {
              _context6.next = 28;
              break;
            }

            paramsV2OK = seoManager.convertParamsForEncode(config.locale, newSeoDec, true);
            delete paramsV2OK.photo;
            delete paramsV2OK.tr;
            delete paramsV2OK.detailAgencyId;
            _urlOK6 = seoManager.encode(paramsV2OK);
            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK6;
            redirectProperties.statusCode = 301;
            return _context6.abrupt("return", redirectProperties);

          case 28:
            level1 = urlSplitted[0].split('-');
            urlSplitted[0] = "affitto-".concat(level1[1]);
            _urlOK5 = "/".concat(urlSplitted.join('/'), "/lista-1");
            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK5;
            redirectProperties.statusCode = 301;
            return _context6.abrupt("return", redirectProperties);

          case 37:
            if (!( // /vendita-residenziale/da-102443/www.immobiliareapogea.it      
            urlSplittedComplete[urlSplittedComplete.length - 1].indexOf('lista-') < 0 && urlSplittedComplete[urlSplittedComplete.length - 1].indexOf('list-') < 0 && urlSplittedComplete[urlSplittedComplete.length - 1].indexOf('mappa-') < 0 && urlSplittedComplete[urlSplittedComplete.length - 1].indexOf('galleria-') < 0 && urlSplittedComplete[urlSplittedComplete.length - 1].indexOf('?') < 0)) {
              _context6.next = 42;
              break;
            }

            redirectProperties.statusCode = 404;
            return _context6.abrupt("return", redirectProperties);

          case 42:
            return _context6.abrupt("return", defaultRedirect);

          case 43:
            _context6.next = 48;
            break;

          case 45:
            _context6.prev = 45;
            _context6.t0 = _context6["catch"](4);
            return _context6.abrupt("return", defaultRedirect);

          case 48:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 45]]);
  }));

  return function middlewareRedirectorPublishers(_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}();

exports.middlewareRedirectorPublishers = middlewareRedirectorPublishers;

var decodeUriMultipleTimes = function decodeUriMultipleTimes(uri, decodedNTimes) {
  decodedNTimes = decodedNTimes + 1;

  try {
    var urlSplittedComplete = decodeURIComponent(uri);

    if (urlSplittedComplete !== uri) {
      return decodeUriMultipleTimes(urlSplittedComplete, decodedNTimes);
    }

    return {
      uri: urlSplittedComplete,
      decodedNTimes: decodedNTimes
    };
  } catch (error) {
    return {
      uri: uri,
      decodedNTimes: decodedNTimes
    };
  }
};

var middlewareRedirectorPublishersSrp = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee8(url, config) {
    var _decodeUriMultipleTim, urlSplittedComplete, decodedNTimes, redirectProperties, defaultRedirect, urlOK, matchPDPAgency, _urlOK7, seoManager, calulcateGeo, levelToCheck, matchNameAndLoc, nameExtracted, locExtracted, matchOneLetter, matchName, matchLoc, _matchOneLetter, fakeUrl, cleanQueryObjectInvalidParams, paramsWithoutGeo, REGEXP_OLD_AGENCIES, MATCH_OLD_AGENCIES, geo, agencyName, paramsWithGeo, paramsV2OK, _urlOK8, urlWithFakeQs, hasFakeQs, encoded_url, encoded_301_url;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _decodeUriMultipleTim = decodeUriMultipleTimes(url, 0), urlSplittedComplete = _decodeUriMultipleTim.uri, decodedNTimes = _decodeUriMultipleTim.decodedNTimes;
            urlSplittedComplete = urlSplittedComplete.split('/').filter(Boolean);
            redirectProperties = {
              isARedirect: false,
              statusCode: 200,
              url: url
            };
            defaultRedirect = _objectSpread({}, redirectProperties);
            _context8.prev = 4;

            if (!(url.indexOf('/agenzie/agenzie-') > -1)) {
              _context8.next = 11;
              break;
            }

            urlOK = "".concat(url.replace('/agenzie/agenzie-', '/agenzie/'));
            redirectProperties.isARedirect = true;
            redirectProperties.url = urlOK;
            redirectProperties.statusCode = 301;
            return _context8.abrupt("return", redirectProperties);

          case 11:
            /**
             * PDP AGENCY URL: /agenzie/e-b-gestioni-immobiliari-srl-176213 
             * REDIRECT TO /agenzie/e-b-gestioni-immobiliari-srl-176213/
            */
            _SeoManagerHelpers.REGEXP_FINISH_WITH_NUMBERS.lastIndex = 0;
            matchPDPAgency = url.match(_SeoManagerHelpers.REGEXP_FINISH_WITH_NUMBERS);

            if (!(matchPDPAgency && urlSplittedComplete && urlSplittedComplete.length === 2)) {
              _context8.next = 19;
              break;
            }

            _urlOK7 = "".concat(url, "/");
            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK7;
            redirectProperties.statusCode = 301;
            return _context8.abrupt("return", redirectProperties);

          case 19:
            seoManager = new _SeoManager["default"](config.domain, config.locale);
            _SeoManagerHelpers.REGEXP_PUBLISHER_NAME_AND_LOC.lastIndex = 0;
            _SeoManagerHelpers.REGEXP_PUBLISHER_NAME.lastIndex = 0;
            _SeoManagerHelpers.REGEXP_PUBLISHER_LOC.lastIndex = 0;
            /**
             * Get the old geo combination from agency location
             * T.B.C. The Class CasaOldSeoManager has already the possibility to 
             * translate old geo configuration to newest 
             * (Same thing for old redirect zones), so we create a fake url to 
             * simulate that process and retreive the geo.
             * @param {String} locExtracted 
             * @returns {Object} geo
             */

            calulcateGeo = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7(locExtracted) {
                var decodedNTimes,
                    fakeUrl,
                    redirectorFakeUrl,
                    seoDec,
                    fakeTempUrl,
                    possibleCity,
                    provinceSlug,
                    _seoDec$geo$,
                    l9,
                    l10,
                    level10,
                    possibleRedirect,
                    decodeForLocation,
                    _args7 = arguments;

                return _regenerator["default"].wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        decodedNTimes = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 1;
                        // while (decodedNTimes !== 1) {
                        //   locExtracted = encodeUriMultipleTimes(locExtracted);
                        //   decodedNTimes = decodedNTimes -1;
                        // }
                        fakeUrl = "/vendita-residenziale/".concat(locExtracted, "/lista-1");
                        _context7.next = 4;
                        return _SeoManager["default"].middlewareRedirector(fakeUrl, config, {
                          from: 'PublisherSrp'
                        });

                      case 4:
                        redirectorFakeUrl = _context7.sent;
                        seoDec = {};

                        if (!redirectorFakeUrl.isARedirect) {
                          _context7.next = 12;
                          break;
                        }

                        _context7.next = 9;
                        return _SeoManager["default"].middlewareRedirector(redirectorFakeUrl.url, config, {
                          from: 'PublisherSrp'
                        });

                      case 9:
                        fakeTempUrl = _context7.sent;
                        fakeUrl = fakeTempUrl.isARedirect ? fakeTempUrl.url : redirectorFakeUrl.url;
                        seoDec = seoManager.decode(fakeUrl);

                      case 12:
                        // TRY TO SAVE URL LIKE THIS: /agenzie/in-milano/lista-1
                        if (!seoDec.geo) {
                          possibleCity = locExtracted.replace('in-', '');
                          provinceSlug = (0, _CasaOldLocationHelper.getProvinceAndState)(possibleCity);

                          if (provinceSlug) {
                            fakeUrl = "/vendita/residenziale/".concat(possibleCity, "/");
                            seoDec = seoManager.decode(fakeUrl);
                          }
                        } // TRY TO SAVE URL WITH OLD ZONE: /agenzie/in-saxarubra++labaro++prima+porta,+roma,+rm,+lazio/lista-3
                        // Using the redirector of a normal srp


                        if (!(seoDec.geo && Array.isArray(seoDec.geo) && seoDec.geo.length === 1 && seoDec.geo[0].l9)) {
                          _context7.next = 21;
                          break;
                        }

                        _seoDec$geo$ = seoDec.geo[0], l9 = _seoDec$geo$.l9, l10 = _seoDec$geo$.l10;
                        level10 = l10 ? "".concat((0, _slugify.slugify)(l10.adm), "/") : '';
                        fakeUrl = "/vendita/residenziale/".concat((0, _slugify.slugify)(l9.adm), "/").concat(level10);
                        _context7.next = 19;
                        return _SeoManager["default"].middlewareRedirector(fakeUrl, config, {
                          from: 'PublisherSrp'
                        });

                      case 19:
                        possibleRedirect = _context7.sent;

                        if (possibleRedirect.isARedirect) {
                          decodeForLocation = seoManager.decode(possibleRedirect.url);
                          seoDec.geo = decodeForLocation.geo;
                        }

                      case 21:
                        return _context7.abrupt("return", seoDec.geo);

                      case 22:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function calulcateGeo(_x9) {
                return _ref10.apply(this, arguments);
              };
            }();

            if (!Array.isArray(urlSplittedComplete)) {
              _context8.next = 69;
              break;
            }

            levelToCheck = urlSplittedComplete[1];
            matchNameAndLoc = _SeoManagerHelpers.REGEXP_PUBLISHER_NAME_AND_LOC.exec(levelToCheck); // value.match(REGEXP_PUBLISHER_NAME_AND_LOC);

            nameExtracted = null;
            locExtracted = null; //CHECK EXTRACTION OF REGULAR EXPRESSION

            if (matchNameAndLoc) {
              nameExtracted = matchNameAndLoc[1].replace('e-', '');
              _SeoManagerHelpers.REGEXP_ATLEAST_ONE_LETTER.lastIndex = 0;
              matchOneLetter = _SeoManagerHelpers.REGEXP_ATLEAST_ONE_LETTER.exec(nameExtracted);
              nameExtracted = matchOneLetter ? nameExtracted : null;
              locExtracted = matchNameAndLoc[2];
            } else {
              matchName = _SeoManagerHelpers.REGEXP_PUBLISHER_NAME.exec(levelToCheck);
              matchLoc = _SeoManagerHelpers.REGEXP_PUBLISHER_LOC.exec(levelToCheck);

              if (matchLoc) {
                locExtracted = matchLoc[1];
              }

              if (matchName) {
                nameExtracted = matchName[1].replace('e-', '');
                _SeoManagerHelpers.REGEXP_ATLEAST_ONE_LETTER.lastIndex = 0;
                _matchOneLetter = _SeoManagerHelpers.REGEXP_ATLEAST_ONE_LETTER.exec(nameExtracted);
                nameExtracted = _matchOneLetter ? nameExtracted : null;
              }
            } // TRY TO DECODE LOCATIONS WITHOUT REGIONS/PROVINCE DELETING "in-" prefix
            // EX: /agenzie/in-giugliano/


            fakeUrl = url.replace('/agenzie/in-', '/agenzie/');

            cleanQueryObjectInvalidParams = function cleanQueryObjectInvalidParams() {
              var qo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              Object.keys(qo).forEach(function (param) {
                var value = qo[param];

                if (!value || value === 'undefined') {
                  delete qo[param];
                }
              });
            };

            paramsWithoutGeo = seoManager.decode(fakeUrl); // urls like /agenzie/${locality}?propertyTypeGroup=undefined
            // urls like /agenzie/${locality}?channel=affitto&propertyTypeGroup=undefined

            cleanQueryObjectInvalidParams(paramsWithoutGeo.queryObject || {}); // SOME URL LIKE /agenzie/e-ARIES%252bSERVIZI%252bIMMOBILIARI-in-00054%253bIntorno%2520a%2520me/lista-1
            // COULD BE REDIRECT WITH PUBLISHERPDP SEO. AVOID IT

            delete paramsWithoutGeo.isPublisherHp;
            delete paramsWithoutGeo.publisherSlug;
            delete paramsWithoutGeo.publisherId; // OLD urls agencies must go to a 404 page

            REGEXP_OLD_AGENCIES = /agenzie\/(e-|dimensione-|per-|in-|da-)/g;
            MATCH_OLD_AGENCIES = REGEXP_OLD_AGENCIES.exec(url);

            if (!MATCH_OLD_AGENCIES) {
              _context8.next = 42;
              break;
            }

            redirectProperties.statusCode = 404;
            return _context8.abrupt("return", redirectProperties);

          case 42:
            _context8.t0 = locExtracted;

            if (!_context8.t0) {
              _context8.next = 47;
              break;
            }

            _context8.next = 46;
            return calulcateGeo(locExtracted, decodedNTimes);

          case 46:
            _context8.t0 = _context8.sent;

          case 47:
            geo = _context8.t0;

            if (!geo && nameExtracted) {
              delete paramsWithoutGeo.geo;
            }
            /**
             * CASE /agenzie/milano?page=1 --> /agenzie/milano/
             */


            if (paramsWithoutGeo && paramsWithoutGeo.queryObject && paramsWithoutGeo.queryObject.page === '1') {
              delete paramsWithoutGeo.queryObject.page;
            }

            agencyName = nameExtracted;
            paramsWithGeo = _objectSpread({}, paramsWithoutGeo, {}, geo && {
              geo: geo
            }, {}, agencyName && {
              agencyName: agencyName
            }, {
              isAgencySrp: true,
              version: 'seo_v2'
            });
            paramsV2OK = seoManager.convertParamsForEncode(config.locale, paramsWithGeo, false);
            delete paramsV2OK.photo;
            _urlOK8 = seoManager.encode(paramsV2OK); // CASE: /agenzie/?x=1

            urlWithFakeQs = _urlOK8.split('/').filter(Boolean);
            hasFakeQs = !!(urlWithFakeQs && urlWithFakeQs.length === 1 && urlWithFakeQs[0].indexOf('?') > -1); // CASE: /agenzie/milanoo/lista-1/ 

            if (!(_urlOK8.indexOf('/lista-') > -1 || hasFakeQs || _urlOK8.indexOf('/agenzie/-provincia/') > -1)) {
              _context8.next = 62;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = '/agenzie/';
            redirectProperties.statusCode = 301;
            return _context8.abrupt("return", redirectProperties);

          case 62:
            encoded_url = encodeURIComponent(decodeURIComponent(url.toLowerCase()));
            encoded_301_url = encodeURIComponent(decodeURIComponent(_urlOK8.toLowerCase()));

            if (!(encoded_301_url !== encoded_url)) {
              _context8.next = 69;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = _urlOK8;
            redirectProperties.statusCode = 301;
            return _context8.abrupt("return", redirectProperties);

          case 69:
            return _context8.abrupt("return", defaultRedirect);

          case 72:
            _context8.prev = 72;
            _context8.t1 = _context8["catch"](4);
            return _context8.abrupt("return", defaultRedirect);

          case 75:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[4, 72]]);
  }));

  return function middlewareRedirectorPublishersSrp(_x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * TECH-6756: ptypes and numrooms inside seofooter have to be redirect to 
 * the main category:
 * /liste/vendita/residenziale/monolocali/ => /liste/vendita/residenziale/
 */


exports.middlewareRedirectorPublishersSrp = middlewareRedirectorPublishersSrp;

var checkSeoFooterRedirectWithPtypesOrNumRooms = function checkSeoFooterRedirectWithPtypesOrNumRooms(_ref11) {
  var oldUrl = _ref11.oldUrl,
      seoDec = _ref11.seoDec,
      redirectProperties = _ref11.redirectProperties,
      seoManager = _ref11.seoManager,
      config = _ref11.config,
      _ref11$isFromHubPage = _ref11.isFromHubPage,
      isFromHubPage = _ref11$isFromHubPage === void 0 ? false : _ref11$isFromHubPage,
      _ref11$onlyAuction = _ref11.onlyAuction,
      onlyAuction = _ref11$onlyAuction === void 0 ? false : _ref11$onlyAuction;
  var _seoDec$propertyTypes = seoDec.propertyTypes,
      propertyTypes = _seoDec$propertyTypes === void 0 ? null : _seoDec$propertyTypes,
      _seoDec$rooms = seoDec.rooms,
      rooms = _seoDec$rooms === void 0 ? null : _seoDec$rooms,
      _seoDec$comuni = seoDec.comuni,
      comuni = _seoDec$comuni === void 0 ? null : _seoDec$comuni,
      _seoDec$buildingCondi = seoDec.buildingCondition,
      buildingCondition = _seoDec$buildingCondi === void 0 ? null : _seoDec$buildingCondi;
  var newUrl = redirectProperties.url;

  if (propertyTypes || rooms) {
    delete seoDec.propertyTypes;
    delete seoDec.rooms;
    var paramsV2OK = seoManager.convertParamsForEncode(config.locale, seoDec, false); // /liste/affitto/attici-mansarde --> /liste/affitto/

    if (!comuni && paramsV2OK.category === 'residenziale') {
      delete paramsV2OK.category;
    }

    var url = seoManager.encode(paramsV2OK);
    newUrl = url;
  }

  if (!propertyTypes && !rooms && !buildingCondition && !comuni && seoDec.category === 'residenziale' && !onlyAuction) {
    var _paramsV2OK7 = seoManager.convertParamsForEncode(config.locale, seoDec, false);

    delete _paramsV2OK7.category;
    delete _paramsV2OK7.geo;
    delete _paramsV2OK7.locations;

    if (!_paramsV2OK7.tr) {
      _paramsV2OK7.tr = 'vendita';
    }

    var _url3 = seoManager.encode(_paramsV2OK7);

    newUrl = _url3;
  }

  if (newUrl !== oldUrl) {
    redirectProperties.isARedirect = true;
    redirectProperties.url = newUrl;
    redirectProperties.statusCode = 301;
  }

  return redirectProperties;
}; // const handleExCommercialPTypeGroups = (seoparams) => {
//   const params = JSON.parse(JSON.stringify(seoparams));
//   const exCommercialGroups = [
//     'capannoni',
//     'uffici',
//     'edifici-palazzi',
//   ];
//   if (exCommercialGroups.includes(params.category)) {
//     params.category = 'commerciale';
//   }
//   return params;
// }


var middlewareRedirectorSEOPages = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee9(url, config) {
    var seoManager, seoDec, redirectProperties, defaultRedirect, urlToUse, newDecoded, newSeoParams, _newUrl, onlyAuction, seoParamsTemp, seoParams, newUrl, paramsV2OK, _url4;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            seoManager = new _SeoManager["default"](config.domain, config.locale);
            seoDec = seoManager.decode(url);
            redirectProperties = {
              isARedirect: false,
              statusCode: 200,
              url: url
            };
            defaultRedirect = _objectSpread({}, redirectProperties);

            if (!(url === '/liste/vendita/')) {
              _context9.next = 9;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = '/';
            redirectProperties.statusCode = 301;
            return _context9.abrupt("return", redirectProperties);

          case 9:
            if (!(url === '/liste/aste/')) {
              _context9.next = 11;
              break;
            }

            return _context9.abrupt("return", defaultRedirect);

          case 11:
            if (!(url.indexOf('undefined') > -1)) {
              _context9.next = 20;
              break;
            }

            urlToUse = url.replace(/undefined/, '').replace(/\/\//, '');
            newDecoded = seoManager.decode(urlToUse);
            newSeoParams = seoManager.convertParamsForEncode(config.locale, newDecoded, false);
            _newUrl = seoManager.encode(newSeoParams);
            redirectProperties.isARedirect = true;
            redirectProperties.url = _newUrl;
            redirectProperties.statusCode = 301;
            return _context9.abrupt("return", redirectProperties);

          case 20:
            onlyAuction = seoDec.features && seoDec.features.length === 1 && seoDec.features.indexOf('asta-immobiliare') > -1;
            redirectProperties = checkSeoFooterRedirectWithPtypesOrNumRooms({
              oldUrl: url,
              seoDec: seoDec,
              seoManager: seoManager,
              redirectProperties: redirectProperties,
              config: config,
              onlyAuction: onlyAuction
            });

            if (!redirectProperties.isARedirect) {
              _context9.next = 24;
              break;
            }

            return _context9.abrupt("return", redirectProperties);

          case 24:
            seoParamsTemp = seoManager.convertParamsForEncode(config.locale, seoDec, false);
            /**
             * FIXME
             * convertParamsForEncode doesnt evaluate only_auction like a feature
             * because it arrives always in other format
             * We force it to insert auction to seoparams
             */

            seoParams = _objectSpread({}, seoParamsTemp, {}, onlyAuction && {
              only_auction: true
            });
            /* TECH-7860 - TRASPASOS 
            const exCommercialPTypeGroupsSeoParams = handleExCommercialPTypeGroups(seoParams)
            /* TECH-7860 - TRASPASOS 
             let newUrl = seoManager.encode(exCommercialPTypeGroupsSeoParams);
            */

            newUrl = seoManager.encode(seoParams);
            /**
             * Normally buildingCondition is built with "in" preposition
             * in this case in homepage no need to add "in"
             * So /vendita/residenziale/in-nuove-costruzioni/ will be
             * /vendita/residenziale/nuove-costruzioni/
            */

            if (seoDec.buildingCondition) {
              paramsV2OK = seoManager.convertParamsForEncode(config.locale, seoDec, false);
              paramsV2OK.category = 'residenziale';
              _url4 = seoManager.encode(paramsV2OK);
              newUrl = _url4.replace('in-', '');
            }

            if (!(url !== newUrl)) {
              _context9.next = 33;
              break;
            }

            redirectProperties.isARedirect = true;
            redirectProperties.url = newUrl;
            redirectProperties.statusCode = 301;
            return _context9.abrupt("return", redirectProperties);

          case 33:
            return _context9.abrupt("return", defaultRedirect);

          case 34:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function middlewareRedirectorSEOPages(_x10, _x11) {
    return _ref12.apply(this, arguments);
  };
}();

exports.middlewareRedirectorSEOPages = middlewareRedirectorSEOPages;

var getPluralPropertyType = function getPluralPropertyType(value) {
  return _SeoManagerHelpers.PROPERTY_TYPES_PLURAL[value] || value;
};

exports.getPluralPropertyType = getPluralPropertyType;

var getPluralLTgGroup = function getPluralLTgGroup(value) {
  return _SeoManagerHelpers.LICENSE_TYPE_GROUPS_PLURAL[value] || value;
};

exports.getPluralLTgGroup = getPluralLTgGroup;

var getNewZonesFrom = function getNewZonesFrom(town) {
  return _NewZonesHelpers.NEW_ZONES[town];
};

exports.getNewZonesFrom = getNewZonesFrom;

var getNewZones = function getNewZones() {
  /**
   * TEMP COMMENTED CREATION OF DYNAMIC JSON FOR HKEY
   */
  // console.log('Object.keys(NEW_ZONES) >>:', Object.keys(NEW_ZONES['alessandria']));
  // const newZonesMerged = Object.keys(NEW_ZONES).reduce((obj, curr) => {
  //   const zones = Object.assign({}, obj, NEW_ZONES[curr]);
  //   return zones;
  // }, {});
  return _hashkeyRedirectObject.allHkeys;
};

exports.getNewZones = getNewZones;

var normalizeSrpUrlData = function normalizeSrpUrlData(data) {
  var queryObject = data.queryObject;
  var ret = {
    queryObject: {},
    features: [],
    filters: {}
  };
  var keysQO = Object.keys(queryObject || {});
  keysQO.forEach(function (k) {
    switch (k) {
      case 'tr':
        if (queryObject.tr && queryObject.tr !== '') {
          ret.tr = queryObject.tr;
        }

        break;

      case 'category':
        if (queryObject.category && queryObject.category !== '') {
          ret.category = queryObject.category;
        }

        break;

      case 'propertyTypeGroup':
        if (queryObject.propertyTypeGroup && queryObject.propertyTypeGroup !== '') {
          ret.propertyTypeGroup = queryObject.propertyTypeGroup;
        }

        break;

      case 'propertyTypes':
        if (queryObject.propertyTypes && queryObject.propertyTypes !== '') {
          var propertyTypes = queryObject.propertyTypes.split(',');

          if (propertyTypes.length === 1) {
            ret.propertyTypes = (0, _SeoManagerHelpers.getObjByCategoryImmotype)('it', propertyTypes[0]);
          }
        }

        break;

      case 'numRoomsMin':
        if (queryObject.numRoomsMin) {
          ret.numRoomsMin = queryObject.numRoomsMin;
        }

        break;

      case 'numRoomsMax':
        if (queryObject.numRoomsMax) {
          ret.numRoomsMax = queryObject.numRoomsMax;
        }

        break;

      case 'buildingCondition':
        if ('buildingCondition' in queryObject && queryObject.buildingCondition) {
          ret.buildingCondition = queryObject.buildingCondition;
        }

        break;

      case 'page':
        if (queryObject.page) {
          ret.page = queryObject.page;
        }

        break;

      case 'sortType':
        if (queryObject.sortType && ret.numRoomsMin && ret.numRoomsMax && ret.numRoomsMin === ret.numRoomsMax) {
          ret.queryObject.sortType = queryObject.sortType;
        }

        break;

      case 'availability':
        if (queryObject.availability === 'nuda-proprieta') {
          ret.availability = queryObject.availability;
          ret.features.push('nuda-proprieta');
        }

        break;

      case 'balcony':
        if (queryObject.balcony) {
          ret.features.push('balcone');
        }

        break;

      case 'garden':
        switch (queryObject.garden) {
          case 'privato':
            ret.features.push('giardino-privato');
            break;

          case 'comune':
            ret.features.push('giardino-comune');
            break;

          case 'comune,privato':
            ret.features.push('giardino');
            break;

          default:
            break;
        }

        break;

      case 'has_swimming_pool':
        if (queryObject.has_swimming_pool) {
          ret.has_swimming_pool = queryObject.has_swimming_pool;
          ret.features.push('piscina');
        }

        break;

      case 'numParkingSpaces':
        if (queryObject.numParkingSpaces === 1 || queryObject.numParkingSpaces === '1') {
          // ret.numParkingSpaces = queryObject.numParkingSpaces;
          ret.features.push('box-posto-auto');
        }

        break;

      case 'only_auction':
        if (queryObject.only_auction) {
          // ret.only_auction = queryObject.only_auction;
          ret.features.push('asta-immobiliare');
        }

        break;

      case 'terrace':
        if (queryObject.terrace) {
          ret.features.push('terrazzo');
        }

        break;

      case 'heatingType':
        if (queryObject.heatingType.length === 2) {
          ret.features.push('riscaldamento');
        } else if (queryObject.heatingType.length === 1) {
          if (queryObject.heatingType.includes('centralizzato')) {
            ret.features.push('riscaldamento-centralizzato');
          } else if (queryObject.heatingType.includes('autonomo')) {
            ret.features.push('riscaldamento-autonomo');
          }
        }

        break;

      case 'lift':
        if (queryObject.lift) {
          ret.features.push(queryObject.lift === 'false' ? 'senza-ascensore' : 'ascensore');
        }

        break;

      case 'sellerType':
        if (queryObject.sellerType && !queryObject.sellerType.includes('agenzie')) {
          ret.publisher = 'privati';
        }

        break;

      case 'poi':
        {
          if (queryObject.poi) {
            try {
              var poi = JSON.parse(queryObject.poi);

              if (poi.subway) {
                ret.poi = {
                  subway: {
                    lte: 400
                  }
                };
              }
            } catch (error) {// miss 
            }
          }

          ;
        }
        break;

      default:
        break;
    }
  });

  if (ret.features.length > 1) {
    ret.features = [];
  }

  return ret;
};

exports.normalizeSrpUrlData = normalizeSrpUrlData;

var getProvinceList = function getProvinceList() {
  return _CasaOldLocationHelper.provinceList;
};

exports.getProvinceList = getProvinceList;

var checkIfFiltersAreValidJustForResidential = function checkIfFiltersAreValidJustForResidential(_ref13) {
  var features = _ref13.features,
      group = _ref13.group;
  return group !== 'residenziale' && group !== 'case' && features.some(function (filter) {
    return _SeoManagerHelpers.FEATURES_VALID_FOR_RESIDENTIAL_ONLY.includes(filter);
  });
};

exports.checkIfFiltersAreValidJustForResidential = checkIfFiltersAreValidJustForResidential;

var checkWhitelistFiltersInCommonWith = function checkWhitelistFiltersInCommonWith(_ref14) {
  var qs = _ref14.qs;
  return Object.keys(qs).some(function (item) {
    return _SeoManagerHelpers.WHITELIST_FILTERS_SEO_TO_SRP_URL.includes(item);
  });
};

exports.checkWhitelistFiltersInCommonWith = checkWhitelistFiltersInCommonWith;

var deleteDoubleFiltersInSeoUrl = function deleteDoubleFiltersInSeoUrl(_ref15) {
  var qs = _ref15.qs;

  try {
    var qsToDelete = _objectSpread({}, qs);

    var filtersToDelete = [];
    var hasToRedirect = false;
    Object.keys(qs).map(function (key) {
      if (_SeoManagerHelpers.DOUBLE_FILTERS_LIST_FOR_REDIRECT_SEO.indexOf(key) > -1) {
        filtersToDelete.push(key);
      }
    });
    var filtersSeoLength = filtersToDelete.length;

    if (filtersToDelete.length > 1) {
      filtersToDelete = [].concat(_toConsumableArray(filtersToDelete), _toConsumableArray(_SeoManagerHelpers.WHITELIST_FILTERS_SEO_TO_SRP_URL));
      filtersToDelete.map(function (curr) {
        if (qsToDelete[curr]) {
          delete qsToDelete[curr];
        }
      });
      hasToRedirect = true;
    }

    return {
      qsToDelete: qsToDelete,
      hasToRedirect: hasToRedirect,
      filtersSeoLength: filtersSeoLength
    };
  } catch (error) {
    console.log('Error trying to delete qs filters >>:', error);
    return {
      qsToDelete: qs,
      hasToRedirect: false,
      filtersSeoLength: 0
    };
  }
};

exports.deleteDoubleFiltersInSeoUrl = deleteDoubleFiltersInSeoUrl;

var getProvincesByShort = function getProvincesByShort() {
  return _SeoManagerHelpers.PROVINCES_BY_SHORT;
};

exports.getProvincesByShort = getProvincesByShort;

var middlewareRedirectorUnregisteredPages = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee10(url, config) {
    var redirectProperties, newUri, _newUri, _newUri2;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            redirectProperties = {
              isARedirect: false,
              statusCode: 200,
              url: url
            };

            if (/^\/search-alert\/activate/.test(url)) {
              newUri = url.replace(/^\/search-alert\/activate/, '/my/alert/attiva');
              redirectProperties.isARedirect = true;
              redirectProperties.url = newUri;
              redirectProperties.statusCode = 301;
            } else if (/^\/search-alert\/edit/.test(url)) {
              _newUri = url.replace(/^\/search-alert\/edit/, '/my/alert/modifica');
              redirectProperties.isARedirect = true;
              redirectProperties.url = _newUri;
              redirectProperties.statusCode = 301;
            } else if (/^\/search-alert\/deactivated/.test(url)) {
              _newUri2 = url.replace(/^\/search-alert\/deactivated/, '/my/alert/disabilita');
              redirectProperties.isARedirect = true;
              redirectProperties.url = _newUri2;
              redirectProperties.statusCode = 301;
            }

            return _context10.abrupt("return", redirectProperties);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function middlewareRedirectorUnregisteredPages(_x12, _x13) {
    return _ref16.apply(this, arguments);
  };
}();

exports.middlewareRedirectorUnregisteredPages = middlewareRedirectorUnregisteredPages;